import { render, staticRenderFns } from "./AttachAdministratorsModal.vue?vue&type=template&id=3105c9e8&scoped=true&"
import script from "./AttachAdministratorsModal.vue?vue&type=script&lang=js&"
export * from "./AttachAdministratorsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3105c9e8",
  null
  
)

export default component.exports